export default __webpack_public_path__ + "assets/webgl/complete-19.9139ce13.jpg";